module.exports = __webpack_public_path__ + "static/media/marketing_chat_color.cfa69073.png";